<!--  -->
<template>
  <div class="">
    <div class="loading-mask">
		<div class="loading-content">
			<div class="loadingtext"> <i class="glyphicon glyphicon-cloud-download">下载中...</i></div>
			<div class="progress">
				<div class="progress-bar"   :style="`width:${percentCompleted}%`">{{percentCompleted}}%</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props:['percentCompleted'],
  data() {
      return {

      };
  },
  methods: {

  },
  mounted() {
    
  },
}
</script>
<style lang='scss' scoped>
	/* 加载遮罩样式 */
	.loading-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.loading-content {
		text-align: center;
		color: white;
	}
	.loadingtext{
		font-size: 16px;
		margin-bottom: 20px;
	}
	.progress{
		width: 500px !important;
		height: 20px !important;
		line-height: 20px !important;
	}
	.progress-bar{
		height: 20px !important;
		line-height: 20px !important;
	}
	/* 禁用滚动 */
	.no-scroll {
		overflow: hidden !important;
	}

	.tipsinfo {
		float: right;
	}
</style>